import getCurrentBrand from "./getCurrentBrand";

export default predefined => JSON.stringify({
  "guest_form": {
    "name": {
      "editable": false,
      "visible": false,
      "value": predefined.name,
    },
    "email": {
      "editable": false,
      "visible": false,
      "value": predefined.email,
    },
  },
  "question_form": {
    "custom_fields": {
      "country": {
        "visible": false,
        "editable": false,
        "value": "", // @todo 2018-10-09 ?
      },
      "boutique": {
        "visible": false,
        "editable": false,
        "value": predefined.boutique
      },
      "attachment": {
        "visible": true,
        "editable": true
      },
      "brand": {
        "visible": false,
        "editable": false,
        "value": getCurrentBrand()
      },
    },
  },
});
